import { render, staticRenderFns } from "./NonVisaCertificationView.vue?vue&type=template&id=0f841484&"
import script from "./NonVisaCertificationView.vue?vue&type=script&lang=js&"
export * from "./NonVisaCertificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports